<mat-dialog-content>
  <header>
    <div class="modal-title-container">
      <h2 class="modal-title">Additional Verification</h2>
      <button mat-dialog-close class="close-btn">
        <app-icon-close width="16" height="16" color="#011835"></app-icon-close>
      </button>
    </div>
    <p class="modal-subtitle">
      To access your credit card ending with ...{{
      modalData.lastFourCardNumber
      }}, please enter the 16 digit card number.
    </p>
  </header>
  <div class="token-ex-container">
    <label class="verify-label" for="origin">Card Number</label>
    <div class="iframe-container">
      <div id="tokenExIframeDiv"></div>
      <div class="error">{{ tokenExErrors }}</div>
    </div>
    <div class="mt-5 be-btn-group be-btn-group--right">
      <button
        mat-dialog-close
        class="befh-btn-link dialog-alternate-close-button"
        >
        Cancel
      </button>
      <button
        class="be-btn be-btn--xsmall-responsive"
        color="primary"
        (click)="onVerify()"
        value="Tokenize"
        [disabled]="isLoading"
        >
        @if (!isLoading) {
          <span>Verify My Card</span>
        }
        <span
          [ngClass]="{ 'spinner-border spinner-border-sm': isLoading }"
          role="status"
          aria-hidden="true"
        ></span>
        @if (isLoading) {
          <span class="sr-only">Loading...</span>
        }
      </button>
    </div>
  </div>
</mat-dialog-content>
